/* Resolve legacy PDP invitations to their existing local form when available. */
(function(){
  'use strict';
  if(!window.__csProductFocusModality){
    window.__csProductFocusModality=true;
    var inputAttribute='data-cs-product-input';
    var keyboardKeys=['Tab','ArrowUp','ArrowDown','ArrowLeft','ArrowRight','Home','End','PageUp','PageDown','Enter',' ','Escape'];
    function pointerInput(event){
      if(event.isPrimary===false || (typeof event.button==='number' && event.button!==0))return;
      document.documentElement.setAttribute(inputAttribute,'pointer');
    }
    function keyboardInput(event){
      if(keyboardKeys.indexOf(event.key)!==-1)document.documentElement.setAttribute(inputAttribute,'keyboard');
    }
    function clearInput(){document.documentElement.removeAttribute(inputAttribute);}
    if('PointerEvent' in window){
      document.addEventListener('pointerdown',pointerInput,{capture:true,passive:true});
    }else{
      document.addEventListener('touchstart',pointerInput,{capture:true,passive:true});
      document.addEventListener('mousedown',pointerInput,{capture:true,passive:true});
    }
    document.addEventListener('keydown',keyboardInput,true);
    window.addEventListener('blur',clearInput);
    window.addEventListener('pagehide',clearInput);
    window.addEventListener('pageshow',function(event){if(event.persisted)clearInput();});
  }
  function bind(){
    var forms=Array.from(document.querySelectorAll('#main form[data-cs-lead-form]')).filter(function(form){return form.id&&!form.closest('[hidden],dialog');});
    if(forms.length!==1)return;
    if(document.querySelector('.c-gift-product-layout')){
      if(!forms[0].hasAttribute('aria-labelledby')&&!forms[0].hasAttribute('aria-label')){
        forms[0].setAttribute('aria-label',document.documentElement.lang.indexOf('en')===0?'Personalise your Gift Card':'Personalizează Gift Card-ul');
      }
      if(!forms[0].hasAttribute('tabindex'))forms[0].setAttribute('tabindex','-1');
    }
    document.querySelectorAll('[data-cs-product-appointment]').forEach(function(link){
      var url;
      try{url=new URL(link.href,location.href);}catch(_){return;}
      if(url.origin!==location.origin)return;
      if(url.hash&&document.getElementById(decodeURIComponent(url.hash.slice(1))))return;
      link.setAttribute('href','#'+forms[0].id);
    });
  }
  /* Keep native anchor navigation and move Gift Card keyboard focus to its named form. */
  if(!window.__csGiftAppointmentFocus){
    window.__csGiftAppointmentFocus=true;
    document.addEventListener('click',function(event){
      if(event.button!==0||event.metaKey||event.ctrlKey||event.shiftKey||event.altKey)return;
      var link=event.target.closest&&event.target.closest('.c-gift-product-layout [data-cs-product-appointment]');
      if(!link||link.closest('[inert],[hidden]'))return;
      var url;
      try{url=new URL(link.href,location.href);}catch(_){return;}
      if(url.origin!==location.origin||url.pathname!==location.pathname||!url.hash)return;
      var form;
      try{form=document.getElementById(decodeURIComponent(url.hash.slice(1)));}catch(_){return;}
      if(!form||!form.matches('form[data-cs-lead-form]')||form.closest('[hidden],dialog'))return;
      requestAnimationFrame(function(){
        if(form.isConnected)form.focus({preventScroll:true});
      });
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',bind);else bind();
  document.addEventListener('shopify:section:load',bind);
})();
